import { Button, Dialog, OnboardingDialog, Snackbar } from "@octopusdeploy/design-system-components";
import { GemIcon } from "@octopusdeploy/design-system-icons";
import { useInlineStatusMutation } from "@octopusdeploy/octopus-react-client";
import type { Repository } from "@octopusdeploy/octopus-server-client";
import type { ReactElement } from "react";
import React, { useRef } from "react";
import { useDialogTrigger } from "../Dialog/DialogTrigger";
import RequestFreeTrialDialog from "../DialogLayout/RequestFreeTrialDialog";
interface RequestFreeTrialUpsellDialogProps {
    featureName: string;
    buttonTitle: string;
    upsellDialogTitle: string;
    children: React.ReactNode;
    docsLabel: string;
    docsLink: string;
    requestTrialDialogTitle: string;
    onRequestTrial: (repository: Repository) => Promise<void>;
    upsellDialogSidePanelImage: ReactElement;
}
export const RequestFeatureTrialUpsellDialog = ({ buttonTitle, upsellDialogTitle, children, docsLabel, docsLink, requestTrialDialogTitle, onRequestTrial: onRequestTrialProp, upsellDialogSidePanelImage, featureName, }: RequestFreeTrialUpsellDialogProps) => {
    const onLatestRequestTrial = useRef(onRequestTrialProp);
    onLatestRequestTrial.current = onRequestTrialProp;
    const { openDialog: openUpsellDialog, closeDialog: closeUpsellDialog, isOpen: isUpsellDialogOpen } = useDialogTrigger();
    const { openDialog: openRequestTrialDialog, closeDialog: closeRequestTrialDialog, isOpen: isRequestTrialDialogOpen } = useDialogTrigger();
    const [showSnackbar, setShowSnackbar] = React.useState(false);
    const { error: errorRequestingTrial, execute: requestFreeTrial, isExecuting: isRequestingFreeTrial, } = useInlineStatusMutation({
        action: onRequestTrialProp,
        name: `request free trial ${featureName}`,
        afterComplete: async () => {
            closeRequestTrialDialog();
            setShowSnackbar(true);
        },
    });
    return (<>
            <Button importance="secondary" icon={<GemIcon size={20}/>} label={buttonTitle} onClick={openUpsellDialog}/>
            <OnboardingDialog open={isUpsellDialogOpen} title={upsellDialogTitle} onClose={closeUpsellDialog} primaryButtonProps={{
            label: "Request Free Trial",
            onClick: () => {
                closeUpsellDialog();
                openRequestTrialDialog();
            },
        }} secondaryButtonProps={{ label: docsLabel, href: docsLink, external: true }} sidePanelImage={upsellDialogSidePanelImage}>
                {children}
            </OnboardingDialog>
            <Dialog open={isRequestTrialDialogOpen}>
                <RequestFreeTrialDialog errors={errorRequestingTrial ? [errorRequestingTrial] : undefined} dialogTitle={requestTrialDialogTitle} onRequestTrial={requestFreeTrial} busy={isRequestingFreeTrial}/>
            </Dialog>
            <Snackbar open={showSnackbar} autoHideDuration={8000} onClose={() => setShowSnackbar(false)} content={"Trial request sent. We\u2019ll email you shortly with the details."} textAlign={"center"} size={"small"}/>
        </>);
};
